import React, { useState } from "react";
import Chevron from "../../assets/images/common/chevron-right.svg";
import "../../assets/css/blooddonation.scss";
import Searchbar from "../../components/common/Searchbar";
import BloodDonationTable from "./../../components/blooddonation/BloodDonationTable";

const BloodDonation = () => {
  const [rows, setRows] = useState([
    {
      number: 1,
      name: "Sohaib",
      age: 35,
      gender: "male",
      bloodgroup: "AB+",
      mobileNo: "+91-955-555-4751",
      city: "Al Jahra",
      address: "Bidadari Park Drive Singapore",
      status: "Available",
    },
    {
      number: 2,
      name: "Sohaib",
      age: 35,
      gender: "male",
      bloodgroup: "AB+",
      mobileNo: "+91-955-555-4751",
      city: "Al Jahra",
      address: "Bidadari Park Drive Singapore",
      status: "Available",
    },
    {
      number: 3,
      name: "Sohaib",
      age: 35,
      gender: "male",
      bloodgroup: "AB+",
      mobileNo: "+91-955-555-4751",
      city: "Al Jahra",
      address: "Bidadari Park Drive Singapore",
      status: "Available",
    },
    {
      number: 4,
      name: "Sohaib",
      age: 35,
      gender: "male",
      bloodgroup: "AB+",
      mobileNo: "+91-955-555-4751",
      city: "Al Jahra",
      address: "Bidadari Park Drive Singapore",
      status: "Available",
    },
    {
      number: 5,
      name: "Sohaib",
      age: 35,
      gender: "male",
      bloodgroup: "AB+",
      mobileNo: "+91-955-555-4751",
      city: "Al Jahra",
      address: "Bidadari Park Drive Singapore",
      status: "Available",
    },
   
  ]);
  const [searchQuery, setSearchQuery] = useState("");

  // Search Functionality
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <>
      <div className="row pl-3 pr-2 pt-4 blooddonation-tab">
        <div className="col-12">
          <p className="mb-0 blooddonation-heading">Manage Blood Donors</p>
        </div>

        <div className="col-12 my-4">
          <div className="row ">
            <div className="col-md-12">
              <p className="blooddonation-breadcrumb">
                <span>DASHBOARD</span>
                <img src={Chevron} />
                <span> BLOOD DONATION</span>
                <img src={Chevron} />
                <span className="current-tab"> DONOR DETAILS</span>
              </p>
            </div>
          </div>
          <div className="row m-0 p-0">
            <Searchbar onChange={handleSearchChange} value={searchQuery} />
          </div>
        </div>

        <div className="col-12 mb-5 pb-5">
          <BloodDonationTable rows={rows} searchQuery={searchQuery} />
        </div>
      </div>
    </>
  );
};

export default BloodDonation;
